// extracted by mini-css-extract-plugin
export default {"particles":"ParticlesBackground_particles__B6RLJ"};